import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Toolbar as RhombusToolbar,
	Button
} from "rhombus-react";

import { deleteVersions } from "reducers/CreativeVersions";
import { confirmDeleteVersion } from "reducers/Confirm";

import { SEARCH_DEBOUNCE, TYPES } from "utils/constants";
import {
	isAfterEffectsCreative,
	isVideoBuilderCreative,
	isMaxDynamicSocialVersions,
	isSocialCreative
} from "utils/common";
import { getRemovableSelectedVersions } from 'utils/VersionActions';

import Permissioned from "widgets/Permissioned";
import SelectCount from 'widgets/toolbars/SelectCount';
import AdvertiserCredits from "widgets/toolbars/AdvertiserCredits";

import GenerateVersionsButton from "./GenerateVersionsButton";
import ImportExportButton from "./ImportExportButton";
import DecisioningButton from "./DecisioningButton";
import AutoClassifyButton from "./AutoClassifyButton";
import PublishSocialVersionsButton from "./PublishSocialVersionsButton";
import UnpublishSocialVersionsButton from "./UnpublishSocialVersionsButton";
import PreviewVersionsButton from "./PreviewVersionsButton";

import "./Toolbar.css";

function DeleteButton(props){
	const {
		libraryId,
		creativeId,
		versionIds,
	} = props;
	const dispatch = useDispatch();

	return (
		<Permissioned domain="Version Library" action="Delete version">
			<Button
				icon="delete"
				style="block"
				theme="red"
				disabled={!versionIds.length}
				onClick={() => dispatch(confirmDeleteVersion(deleteVersions, {
					libraryId,
					creativeId,
					versionIds,
				}))}
			>
				Delete Versions{ versionIds.length ? ` (${versionIds.length})` : null }
			</Button>
		</Permissioned>
	);
}

export default function Toolbar({ searchTerm, handleSearch, creativeId, libraryId }){
	var $buttons = null
		, { currentSelection, versions, totalItems, creativeDetails } = useSelector(state => ({
			currentSelection: state.selected.versions,
			versions: state.creativeVersions.items,
			totalItems: state.creativeVersions.totalItems,
			creativeDetails: state.creativeDetails,
		}))
		, isSomethingSelected = (currentSelection.length > 0)
		, searchProps = {
			isDisabled: isSomethingSelected,
		}
		;

	const { isLoaded } = creativeDetails;
	const isAfterEffects = isAfterEffectsCreative(creativeDetails);
	const isSocial = isSocialCreative(creativeDetails);
	const isVideoBuilder = isVideoBuilderCreative(creativeDetails);
	const isMaxSocialVersions = isMaxDynamicSocialVersions(totalItems, creativeDetails);

	if(isSomethingSelected) {
		const removableVersionIds = getRemovableSelectedVersions(currentSelection, versions);

		$buttons = [
			<div key="divider" className="toolbar-divider" />,
			<SelectCount key="selected" type={TYPES.VERSIONS} />,
			<AutoClassifyButton key="classify" creativeId={creativeId} />,
			<PublishSocialVersionsButton key="publishSocial" libraryId={libraryId} />,
			<UnpublishSocialVersionsButton key="unpublishSocial" libraryId={libraryId} />,
			<DeleteButton key="delete" {...{ libraryId, creativeId, versionIds: removableVersionIds }} />,
		];
	}

	return (
		<RhombusToolbar
			className="version-toolbar"
			search
			searchDebounce = {SEARCH_DEBOUNCE}
			onSearch = {handleSearch}
			searchValue = {searchTerm}
			searchProps = {searchProps}
		>
			<div className = "action-button-side flex-center">
				<GenerateVersionsButton key="generate" isDisabled={!isLoaded || isAfterEffects || isVideoBuilder || isMaxSocialVersions} />
				<DecisioningButton key="decisioning" isDisabled={!isLoaded || isSocial || isVideoBuilder} />
				<PreviewVersionsButton key="preview" creativeId={creativeId} isSocial={isSocial} isDisabled={!isLoaded} />
				{$buttons}
			</div>
			<AdvertiserCredits />
			<div className="import-export"><ImportExportButton key="importExport" /></div>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "VersionsToolbar";
